var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQtAudio = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 280 280"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M170 58.04v163.431c0 17.818-21.543 26.742-34.142 14.142l-50-50a20 20 0 0 0-14.142-5.858H40c-11.046 0-20-8.954-20-20v-40c0-11.045 8.954-20 20-20h31.716a20 20 0 0 0 14.142-5.857l50-50C148.457 31.298 170 40.222 170 58.04m40 31.715c27.614 0 50 22.386 50 50s-22.386 50-50 50c-5.523 0-10-4.477-10-10v-10c0-5.523 4.477-10 10-10 11.046 0 20-8.954 20-20s-8.954-20-20-20c-5.523 0-10-4.477-10-10v-10c0-5.522 4.477-10 10-10"
})));
export default SvgQtAudio;